<div class="row justify-content-center event__image type-1 m-0">
    <div *ngIf="this.eventPageConfig" class="event__image-wrapper type-1">
        <img [src]="eventPageData.coverImage" class="align-center w-100" alt=""/>
    </div>

    <div class="px-0 col-12 col-md-9 col-lg-8 d-flex justify-content-center event__information type-1">
        <div class="mx-0 row event__information-container type-1">
            <div class="col-12 col-md-8 left-side px-3 pt-3 pb-2 py-md-4">
            <ng-container *ngIf="eventPageData.info">
                <h1 class="event__title">
                <span [innerHTML]="eventPageData.name"></span>
                </h1>
            </ng-container>
            <ng-container *ngIf="this.eventPageConfig.hybridEventInfo; else elseBlock">
                @if(eventPageData.showDateTime && eventPageData.timeHybrid) {
                    @if(eventPageData.timeHybrid.virtual && !this.eventPageConfig.hideVirtual) {
                        <div class="event__date hybrid">
                            <span class="pr-2">Virtual: </span>
                            <app-icon-calendar [color]="infoContainerColors.informationContainerDateColor" [theme]="eventPageService.selectedTheme"></app-icon-calendar>
                            <span class="date">{{ (eventPageData.timeHybrid.virtual | date: 'mediumDate') + ' / ' + (eventPageData.timeHybrid.virtual | date: 'shortTime') + ' ' + timezoneAbbreviation }}</span>
                        </div>
                    }
                    @if(eventPageData.timeHybrid.inPerson && !this.eventPageConfig.hideInPerson) {
                        <div class="event__date hybrid">
                            <span class="pr-2">In-Person: </span>
                            <app-icon-calendar [color]="infoContainerColors.informationContainerDateColor" [theme]="eventPageService.selectedTheme"></app-icon-calendar>
                            <span class="date">{{ (eventPageData.timeHybrid.inPerson | date: 'mediumDate') + ' / ' + (eventPageData.timeHybrid.inPerson | date: 'shortTime') + ' ' + timezoneAbbreviation }}</span>
                        </div>
                    }
                } @else if(!eventPageData.showDateTime) {
                    <div class="event__date event__date--custom-label">
                        <span class="date pl-0"> {{ eventPageData.customDateTimeLabel }}</span>
                    </div>
                }
            </ng-container>
            <ng-template #elseBlock>
                @if(eventPageData.showDateTime) {
                    <div class="event__date">
                        <app-icon-calendar [color]="infoContainerColors.informationContainerDateColor" [theme]="eventPageService.selectedTheme"></app-icon-calendar>
                        <span class="date"> {{ (eventPageData.time | date: 'mediumDate') + ' / ' + (eventPageData.time | date: 'shortTime') + ' ' + timezoneAbbreviation }}</span>
                    </div>
                } @else {
                    <div class="event__date event__date--custom-label">
                        <span class="date pl-0"> {{ eventPageData.customDateTimeLabel }}</span>
                    </div>
                }
            </ng-template>

            <ng-container *ngIf="eventPageData.address">
                <div class="event__venue-wrapper">
                <ng-container *ngIf="eventPageData.venueName else withoutEventName;">
                    <div class="event__venue">
                    <app-icon-location [color]="infoContainerColors.informationContainerDateColor" [theme]="eventPageService.selectedTheme"></app-icon-location>
                    <div [innerText]="eventPageData.venueName"></div> :
                    </div>
                    <div class="eventPageData.address" [innerText]="eventPageData.address"></div>
                </ng-container>
                <ng-template #withoutEventName>
                    <div class="event__venue d-flex">
                    <app-icon-location [color]="infoContainerColors.informationContainerDateColor" [theme]="eventPageService.selectedTheme"></app-icon-location>
                    <div class="eventPageData.address pl-2" [innerText]="eventPageData.address"></div>
                    </div>
                </ng-template>
                </div>
            </ng-container>

            <ng-container *ngIf="eventPageData.info">
                <app-read-more *ngIf="eventPageData.desc" 
                [text]="eventPageData.desc" 
                [classes]="'event__desc'"
                >
                </app-read-more>
            </ng-container>
            </div>
            <ng-container>
            <div *ngIf="!eventPageConfig.registrations.length"
                    class="col-12 col-md-4 text-center text-md-left right-side justify-content-center align-items-center pt-2 pr-3 pb-3 pl-3 pt-lg-3">
                @if (!hideShareSection) {
                    <div class="share-icons" (click)="eventPageService.onStopPropagation($event)">
                        <div class="title">Share:</div>
                        <div class="icon-wrapper">
                            <app-icon-twitter [color]="infoContainerColors.informationContainerShareIconsTextColor" [theme]="eventPageService.selectedTheme"
                                            (click)="eventPageService.onClickTwitter(eventPageData.name, eventPageConfig.orgInfo.name, (eventPageData.timeHybrid ? eventPageData.timeHybrid.virtual : eventPageData.time))"></app-icon-twitter>
                            <app-icon-facebook [color]="infoContainerColors.informationContainerShareIconsTextColor" [theme]="eventPageService.selectedTheme"
                                                (click)="eventPageService.onClickFB(eventPageData.name, eventPageConfig.orgInfo.name, (eventPageData.timeHybrid ? eventPageData.timeHybrid.virtual : eventPageData.time))"></app-icon-facebook>
                            <app-icon-copy [color]="infoContainerColors.informationContainerShareIconsTextColor" [theme]="eventPageService.selectedTheme" (click)="eventPageService.onShowToaster()"
                                            [cdkCopyToClipboard]="eventPageService.onCopy()"></app-icon-copy>
                        </div>
                    </div>
                }
            </div>
            <div *ngIf="eventPageConfig.registrations.length === 1"
                    class="col-12 col-md-4 text-center text-md-left right-side justify-content-center align-items-center">
                <div class="button-wrapper">
                    <a [ngClass]="registerBtnClasses" [href]="eventPageConfig.registrations[0].link" target="_blank"
                        class="btn btn-sm btn--black modal-pledge-button join-button"
                        [innerHTML]="registerBtnText">
                    </a>
                </div>

                @if (!hideShareSection) {
                    <div class="share-icons" (click)="eventPageService.onStopPropagation($event)">
                        <div class="title">Share:</div>
                        <div class="icon-wrapper">
                            <app-icon-twitter [color]="infoContainerColors.informationContainerShareIconsTextColor" [theme]="eventPageService.selectedTheme"
                                            (click)="eventPageService.onClickTwitter(eventPageData.name, eventPageConfig.orgInfo.name, (eventPageData.timeHybrid ? eventPageData.timeHybrid.virtual : eventPageData.time))"></app-icon-twitter>
                            <app-icon-facebook [color]="infoContainerColors.informationContainerShareIconsTextColor" [theme]="eventPageService.selectedTheme"
                                                (click)="eventPageService.onClickFB(eventPageData.name, eventPageConfig.orgInfo.name, (eventPageData.timeHybrid ? eventPageData.timeHybrid.virtual : eventPageData.time))"></app-icon-facebook>
                            <app-icon-copy [color]="infoContainerColors.informationContainerShareIconsTextColor" (click)="eventPageService.onShowToaster()" [theme]="eventPageService.selectedTheme"
                                            [cdkCopyToClipboard]="eventPageService.onCopy()"></app-icon-copy>
                        </div>
                    </div>
                }
            </div>
            <div *ngIf="eventPageConfig.registrations.length > 1" class="col-12 col-md-4 text-center text-md-left right-side">
                <div class="button-wrapper pb-3">
                    <div [ngClass]="{'appearance': expanded}" class="custom-popover">
                        <div class="button-panel">
                        <span aria-hidden="true" (click)="expanded = false" class="close-button">×</span>
                        <div class="sub-header">
                            <div class="title" [innerHTML]="eventPageData.name"></div>
                        </div>
                        <div class="wrapper">
                            <ng-container *ngFor="let button of eventPageConfig.registrations; let i = index; trackBy:eventPageService.identify">
                            <div class="button-row row mx-0">
                                <div class="register-btn-desc col-6 col-md-8" [innerHTML]="button.desc"></div>
                                <div class="col-6 pl-0 col-md-4 register-btn justify-content-end">
                                <a [ngClass]="{'disabled': button.disabledButton()}" [href]="button.link" target="_blank" class="btn btn-sm btn--black join-button"
                                    [innerHTML]="button.label"></a>
                                </div>
                            </div>
                            </ng-container>
                        </div>
                        </div>
                    </div>
                </div>
                <div [ngClass]="registerBtnClasses" (click)="expanded = !expanded" class="btn btn-sm btn--black modal-pledge-button join-button"> 
                    {{ registerBtnText }}
                </div>
                @if (!hideShareSection) {
                    <div class="share-icons">
                        <div class="title">Share:</div>
                        <div class="icon-wrapper">
                            <app-icon-twitter [color]="infoContainerColors.informationContainerShareIconsTextColor"  [theme]="eventPageService.selectedTheme"
                                            (click)="eventPageService.onClickTwitter(eventPageData.name, eventPageConfig.orgInfo.name, (eventPageData.timeHybrid ? eventPageData.timeHybrid.virtual : eventPageData.time))"></app-icon-twitter>
                            <app-icon-facebook [color]="infoContainerColors.informationContainerShareIconsTextColor"  [theme]="eventPageService.selectedTheme"
                                                (click)="eventPageService.onClickFB(eventPageData.name, eventPageConfig.orgInfo.name, (eventPageData.timeHybrid ? eventPageData.timeHybrid.virtual : eventPageData.time))"></app-icon-facebook>
                            <app-icon-copy [color]="infoContainerColors.informationContainerShareIconsTextColor"  [theme]="eventPageService.selectedTheme" (click)="eventPageService.onShowToaster()"
                                            [cdkCopyToClipboard]="eventPageService.onCopy()"></app-icon-copy>
                        </div>
                    </div>
                }
            </div>
            </ng-container>
        </div>
    </div>
</div>